{
  "title": "عملاء الذمم",
  "addDebtor": "إضافة مدين",
  "editDebtor": "تعديل المدين",
  "vehiclesPage": "المركبات",
  "addVehicle": "إضافة مركبة",
  "adjustBalance": "تعديل إجمالي الدين",
  "searchLabel": "البحث بالاسم أو رقم الهاتف",
  "searchPlaceholder": "البحث بالاسم أو رقم الهاتف...",
  "fields": {
    "name": "اسم المدين",
    "phone": "رقم الهاتف",
    "debtLimit": "سقف الدين",
    "branch": "الفرع",
    "notes": "ملاحظات",
    "vehiclePlate": "رقم المركبة",
    "amount": "المبلغ",
    "phoneInvalid": "رقم الهاتف غير صالح"
  },
  "columns": {
    "number": "الرقم",
    "name": "اسم المدين",
    "phone": "رقم الهاتف",
    "branch": "الفرع",
    "totalDebt": "إجمالي الدين",
    "debtLimit": "سقف الدين",
    "linkStatus": "ربط العملاء",
    "createdBy": "تم الإنشاء بواسطة",
    "createdAt": "تاريخ الإنشاء",
    "notes": "ملاحظات",
    "addedAt": "تاريخ الإضافة",
    "vehiclePlate": "رقم المركبة",
    "actions": "إجراءات"
  },
  "shared": "مشترك",
  "linkStatus": {
    "LINKED": "مرتبط",
    "PENDING": "بانتظار الربط",
    "INVALID_PHONE": "رقم غير صالح"
  },
  "linkStatusFilterLabel": "ربط العملاء",
  "linkStatusFilterAll": "جميع حالات الربط",
  "branchFilterShared": "مشترك",
  "invalidPhoneFlag": "رقم غير صالح",
  "totals": {
    "totalDebts": "مجموع الديون"
  },
  "drawer": {
    "createDescription": "أدخل بيانات المدين الجديد. الحقول المطلوبة مميزة بعلامة النجمة.",
    "editDescription": "عدل بيانات المدين. لا يمكن تعديل إجمالي الدين من هنا.",
    "requiredFieldsNote": "الحقول المطلوبة مميزة بعلامة النجمة",
    "saving": "جاري الحفظ...",
    "branchPlaceholder": "مشترك (بدون فرع)",
    "discardTitle": "تجاهل التغييرات؟",
    "discardDescription": "لن يتم حفظ التغييرات التي أدخلتها.",
    "discardConfirm": "تجاهل",
    "discardCancel": "متابعة التعديل"
  },
  "vehicleDrawer": {
    "title": "إضافة مركبة",
    "description": "أدخل رقم المركبة. الحقول المطلوبة مميزة بعلامة النجمة."
  },
  "adjustDialog": {
    "title": "تعديل إجمالي الدين",
    "description": "أدخل مبلغا موجبا لزيادة الدين أو سالبا لتخفيضه لـ{{name}}.",
    "currentBalance": "الرصيد الحالي",
    "resultingBalance": "الرصيد بعد التعديل",
    "confirm": "تأكيد",
    "amountRequired": "أدخل مبلغا غير صفري"
  },
  "confirmDelete": {
    "title": "حذف المدين؟",
    "description": "سيتم حذف المدين \"{{name}}\" (الرصيد الحالي {{balance}}). يمكن استعادته لاحقا من سلة المحذوفات."
  },
  "confirmDeleteVehicle": {
    "title": "حذف المركبة؟",
    "description": "سيتم حذف المركبة \"{{plate}}\". يمكن استعادتها لاحقا من سلة المحذوفات."
  },
  "toasts": {
    "created": "تم إنشاء المدين بنجاح",
    "updated": "تم تحديث المدين بنجاح",
    "deleted": "تم حذف المدين بنجاح",
    "balanceAdjusted": "تم تعديل إجمالي الدين بنجاح",
    "vehicleCreated": "تم إضافة المركبة بنجاح",
    "vehicleDeleted": "تم حذف المركبة بنجاح"
  },
  "rowActions": {
    "vehicles": "المركبات",
    "trigger": "إجراءات {{name}}"
  },
  "vehiclesHeader": {
    "balance": "الرصيد الحالي",
    "debtLimit": "سقف الدين",
    "back": "العودة إلى عملاء الذمم"
  },
  "empty": {
    "noResults": "لا توجد نتائج",
    "noData": "لا توجد بيانات متاحة",
    "noVehicles": "لا توجد مركبات لهذا المدين"
  }
}
